import { render, staticRenderFns } from "./table-row.vue?vue&type=template&id=64fe3866&scoped=true"
import script from "./table-row.vue?vue&type=script&lang=ts"
export * from "./table-row.vue?vue&type=script&lang=ts"
import style0 from "./table-row.vue?vue&type=style&index=0&id=64fe3866&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fe3866",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64fe3866')) {
      api.createRecord('64fe3866', component.options)
    } else {
      api.reload('64fe3866', component.options)
    }
    module.hot.accept("./table-row.vue?vue&type=template&id=64fe3866&scoped=true", function () {
      api.rerender('64fe3866', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/ui/table/table-row.vue"
export default component.exports